import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inbound_order_details_report_auto_emailService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, orderClassIds?: number[], dateType?: string, reference?: string, orderIds?: number[], materialIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, Material?: { Description?: string, LookupCode?: string } }, ActualPackagedPack?: { Name?: string, ShortName?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, orderClassIds?: number[], dateType?: string, reference?: string, orderIds?: number[], materialIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, Material?: { Description?: string, LookupCode?: string } }, ActualPackagedPack?: { Name?: string, ShortName?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, orderClassIds?: number[], dateType?: string, reference?: string, orderIds?: number[], materialIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, Order?: { LookupCode?: string, OwnerReference?: string, Project?: { LookupCode?: string }, Account?: { Id?: number, Name?: string } }, Shipment?: { ShippedDate?: string }, ActualTargetLicensePlate?: { Id?: number, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Location?: { Name?: string }, Status?: { Name?: string } }, VendorLot?: { ExpirationDate?: string, LookupCode?: string, Material?: { Description?: string, LookupCode?: string } }, ActualPackagedPack?: { Name?: string, ShortName?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, orderClassIds?: number[], dateType?: string, reference?: string, orderIds?: number[], materialIds?: number[]    }) {
      return false;
    }
}
